<template>
    <button class="button button_view_icon button_theme_base mtb__-4"
            :disabled="disabled"
            @click.stop="setUnitFns"
    >
        <span class="icon">
            <span class="icon__symbol">
                <SvgIcon class="icon" name="common__copy" :title="$t('Copy') + ' ' + $t('Shipment.Shipment ID')"/>
            </span>
        </span>
    </button>
</template>
<script>
    import copyMixin from "@/mixins/copyMixin";
    import {mapGetters} from "vuex";
    import {useToast} from "vue-toastification";

    export default {
        name: 'ShipmentList_menu_edit',
        mixins: [copyMixin],
        props: {
            packageId: Number,
            shipmentId: Number,
            disabled: Boolean,
        },
        data() {
            return {
                toast: useToast()
            }
        },
        computed: {
            ...mapGetters([
                "getShipmentsPackagesById",
                "getShipmentsById",
            ])
        },
        methods: {
            setUnitFns() {
                this.shipmentCopyText()
            },
            shipmentCopyText() {
                let text = '';

                if (this.packageId) {
                    text = this.getShipmentsPackagesById[this.packageId]?.name
                } else
                if (this.shipmentId) {
                    let shipment = this.getShipmentsById[this.shipmentId]
                    text = shipment?.package_id ? this.getShipmentsPackagesById[shipment.package_id]?.name : shipment?.name
                }

                if (!text) {
                    this.toast.warning(this.$t('errors.Copy error, please copy manually'));
                    return false;
                }
                this.copyText(text)
            },
        },
    }
</script>